import { io } from 'socket.io-client';

const SOCKET_URL = 'https://chat-backend.avtodas.am';

class SocketService {
    constructor() {
        this.socket = io(SOCKET_URL, { autoConnect: true });
    }

    // Emitters
    joinPool(data) {
        this.socket.emit('join_pool', data);
    }

    leave() {
        this.socket.emit('leave');
    }

    nextPartner(prefs) {
        this.socket.emit('next_partner', prefs);
    }

    sendMessage(text) {
        this.socket.emit('send_message', text);
    }

    sendTyping(isTyping) {
        this.socket.emit('typing', isTyping);
    }

    sendReadReceipt(msgId) {
        this.socket.emit('read_receipt', msgId);
    }

    report(reason) {
        this.socket.emit('report', { reason });
    }

    adminJoin(password) {
        this.socket.emit('admin_join', password);
    }

    getArchive() {
        this.socket.emit('get_archive');
    }

    adminSendMessage(matchId, text) {
        this.socket.emit('admin_send_message', { matchId, text });
    }

    clearArchive() {
        this.socket.emit('clear_archive');
    }

    // Listeners
    onStatsUpdate(cb) { this.socket.on('stats_update', cb); }
    onMatched(cb) { this.socket.on('matched', cb); }
    onSearching(cb) { this.socket.on('searching', cb); }
    onMessage(cb) { this.socket.on('message', cb); }
    onTyping(cb) { this.socket.on('typing', cb); }
    onPartnerRead(cb) { this.socket.on('partner_read', cb); }
    onPartnerLeft(cb) { this.socket.on('partner_left', cb); }
    onReportSuccess(cb) { this.socket.on('reported_success', cb); }
    onAdminMatches(cb) { this.socket.on('admin_matches_update', cb); }
    onArchiveData(cb) { this.socket.on('archive_data', cb); }
    onAdminError(cb) { this.socket.on('admin_error', cb); }
    onAdminSuccess(cb) { this.socket.on('admin_success', cb); }
    onDisconnect(cb) { this.socket.on('disconnect', cb); }
    onConnect(cb) { this.socket.on('connect', cb); }

    // Utility
    get id() {
        return this.socket.id;
    }

    disconnect() {
        this.socket.removeAllListeners();
    }
}

export const socketService = new SocketService();